import { get } from "@/utils/get";

import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";

function InputNumber({ error, onChange, ...props }) {
  const preventDefaultChange = (event) => {
    const modifiedValue = event.target.value;

    if (!isNaN(modifiedValue) && modifiedValue.indexOf("e") === -1) {
      event.target.value = modifiedValue;
      onChange(props.id, modifiedValue);
    }
  };

  return (
    <TextField
      {...props}
      fullWidth
      placeholder={props.name}
      value={props.value ?? ""}
      error={!!get(props.name ?? props.id, error) || error === true}
      helperText={get(props.name ?? props.id, error)?.[0] || props.helperText}
      type="tel"
      onChange={preventDefaultChange}
    />
  );
}

InputNumber.propTypes = {
  onChange: PropTypes.func,
  name: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  helperText: PropTypes.string,
  id: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default InputNumber;
